(function () {
  var ZONES = ['center', 'mid', 'north', 'south'];

  // Fallback used when the theme settings are empty or unreadable.
  var DEFAULT_RATES = {
    mattress: {
      center: [250, 400, 600, 800],
      mid: [300, 450, 650, 850],
      north: [350, 600, 850, 1000],
      south: [450, 800, 1150, 1400]
    },
    compact: {
      center: [350, 650],
      mid: [400, 750],
      north: [450, 850],
      south: [600, 1100]
    },
    designed: {
      center: [450, 850],
      mid: [500, 900],
      north: [550, 1000],
      south: [700, 1300]
    },
    adjustable: {
      center: [500, 950],
      mid: [550, 1050],
      north: [600, 1150],
      south: [800, 1500]
    },
    extra: {
      center: [100, 250, 450],
      mid: [100, 250, 450],
      north: [100, 250, 450],
      south: [300, 600, 900, 1200]
    },
    floor: { standard: 50, bulky: 100 }
  };

  var ZONE_LABELS = {
    center: 'בין חיפה לבאר שבע',
    mid: 'באר שבע עד דימונה / חיפה עד טבריה',
    north: 'אחרי טבריה עד קרית שמונה',
    south: 'אחרי דימונה עד אילת'
  };

  var saveTimer = null;

  function numList(value, fallback) {
    var raw = Array.isArray(value) ? value : String(value == null ? '' : value).split(',');
    var list = [];
    raw.forEach(function (entry) {
      var num = parseFloat(entry);
      if (!isNaN(num)) list.push(num);
    });
    return list.length ? list : fallback;
  }

  function num(value, fallback) {
    var parsed = parseFloat(value);
    return isNaN(parsed) ? fallback : parsed;
  }

  function zoneTables(source, fallback) {
    var out = {};
    ZONES.forEach(function (zone) {
      out[zone] = numList(source ? source[zone] : null, fallback[zone]);
    });
    return out;
  }

  function readRates(root) {
    var el = root.querySelector('[data-shipping-rates]');
    var raw = {};
    if (el) {
      try {
        raw = JSON.parse(el.textContent) || {};
      } catch (e) {
        raw = {};
      }
    }
    var floor = raw.floor || {};
    return {
      mattress: zoneTables(raw.mattress, DEFAULT_RATES.mattress),
      compact: zoneTables(raw.compact, DEFAULT_RATES.compact),
      designed: zoneTables(raw.designed, DEFAULT_RATES.designed),
      adjustable: zoneTables(raw.adjustable, DEFAULT_RATES.adjustable),
      extra: zoneTables(raw.extra, DEFAULT_RATES.extra),
      floor: {
        standard: num(floor.standard, DEFAULT_RATES.floor.standard),
        bulky: num(floor.bulky, DEFAULT_RATES.floor.bulky)
      }
    };
  }

  function bedPair(table) {
    var one = table && table.length ? table[0] : 0;
    var two = table && table.length > 1 ? table[1] : one;
    return { one: one, two: two };
  }

  function qtyFromTable(table, qty, step) {
    if (qty < 1) return 0;
    if (qty <= table.length) return table[qty - 1];
    return table[table.length - 1] + (qty - table.length) * (step || 200);
  }

  function extraFromTable(table, extraQty) {
    if (extraQty < 1) return 0;
    if (extraQty <= table.length) return table[extraQty - 1];
    var last = table[table.length - 1];
    var prev = table.length > 1 ? table[table.length - 2] : 0;
    var step = last - prev || 300;
    return last + (extraQty - table.length) * step;
  }

  function bedsPrice(map, qty) {
    if (qty < 1) return 0;
    if (qty === 1) return map.one;
    if (qty === 2) return map.two;
    return map.two + (qty - 2) * Math.round((map.two - map.one) * 0.85);
  }

  function countCats(items) {
    var c = { mattress: 0, compact: 0, designed: 0, adjustable: 0, other: 0 };
    items.forEach(function (item) {
      var key = c[item.cat] != null ? item.cat : 'other';
      c[key] += parseInt(item.qty, 10) || 0;
    });
    return c;
  }

  function calculate(items, zone, floor, hasElevator, rates) {
    var counts = countCats(items);
    var parts = [];
    var total = 0;
    var bulky = counts.designed + counts.adjustable > 0;

    if (counts.designed) {
      var d = bedsPrice(bedPair(rates.designed[zone]), counts.designed);
      total += d;
      parts.push('מיטה מעוצבת × ' + counts.designed + ': ₪' + d);
    }

    if (counts.adjustable) {
      var a = bedsPrice(bedPair(rates.adjustable[zone]), counts.adjustable);
      total += a;
      parts.push('מיטה מתכווננת × ' + counts.adjustable + ': ₪' + a);
    }

    if (counts.compact) {
      var cPrice = bedsPrice(bedPair(rates.compact[zone]), counts.compact);
      total += cPrice;
      parts.push('מיטת 1.5 / נוער / ספה × ' + counts.compact + ': ₪' + cPrice);
    }

    if (counts.mattress) {
      var withBed = counts.designed || counts.adjustable || counts.compact;

      if (withBed) {
        var extra = extraFromTable(rates.extra[zone], counts.mattress);
        total += extra;
        parts.push('מזרן נוסף × ' + counts.mattress + ': ₪' + extra);
      } else {
        var m = qtyFromTable(rates.mattress[zone], counts.mattress, 200);
        total += m;
        parts.push('מזרנים × ' + counts.mattress + ': ₪' + m);
      }
    }

    if (!total && counts.other && !counts.mattress && !counts.compact && !counts.designed && !counts.adjustable) {
      return { total: 0, parts: ['פריטים קטנים — אין תוספת הובלה בטבלה'], crane: false, empty: true };
    }

    var floorNum = parseInt(floor, 10);
    if (!hasElevator && floorNum >= 4) {
      var steps = Math.min(floorNum, 5) - 3;
      var rate = bulky ? rates.floor.bulky : rates.floor.standard;
      var floorFee = steps * rate;
      total += floorFee;
      parts.push('תוספת קומות: ₪' + floorFee);
    }

    return {
      total: total,
      parts: parts,
      crane: !hasElevator && floorNum >= 6,
      empty: false
    };
  }

  function money(n) {
    return '₪' + n;
  }

  function readItems(root) {
    var el = root.querySelector('[data-shipping-items]');
    if (!el) return [];
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return [];
    }
  }

  function updateView(root) {
    var zone = root.querySelector('[data-ship-zone]');
    var floor = root.querySelector('[data-ship-floor]');
    var elevator = root.querySelector('[data-ship-elevator]');
    var result = root.querySelector('[data-ship-result]');
    var need = root.querySelector('[data-ship-need]');
    var totalEl = root.querySelector('[data-ship-total]');
    var breakdown = root.querySelector('[data-ship-breakdown]');
    var crane = root.querySelector('[data-ship-crane]');
    var cashAttr = root.querySelector('[data-ship-cash-attr]');
    var zoneLabel = root.querySelector('[data-ship-zone-label]');
    var form = root.closest('form') || document;
    var tabTotal = form.querySelector('[data-ship-tab-total]');

    if (!zone || !floor) return null;

    var ready = zone.value && floor.value !== '';
    var consented = applyConsent(form);

    if (!ready) {
      if (result) result.hidden = true;
      if (need) need.hidden = false;
      if (cashAttr) cashAttr.value = '';
      if (zoneLabel) zoneLabel.value = '';
      if (tabTotal) tabTotal.textContent = '';
      return {
        delivery_consent: consented ? 'yes' : 'no'
      };
    }

    var estimate = calculate(
      readItems(root),
      zone.value,
      floor.value,
      !!(elevator && elevator.checked),
      readRates(root)
    );

    if (result) result.hidden = false;
    if (need) need.hidden = true;
    if (totalEl) totalEl.textContent = money(estimate.total);
    if (breakdown) breakdown.textContent = estimate.parts.join(' · ');
    if (crane) crane.hidden = !estimate.crane;
    if (cashAttr) cashAttr.value = money(estimate.total);
    if (zoneLabel) zoneLabel.value = ZONE_LABELS[zone.value] || zone.value;
    if (tabTotal) tabTotal.textContent = money(estimate.total);

    return {
      delivery_zone: zone.value,
      delivery_zone_label: ZONE_LABELS[zone.value] || zone.value,
      delivery_floor: floor.value,
      delivery_elevator: elevator && elevator.checked ? 'yes' : 'no',
      delivery_cash: money(estimate.total),
      delivery_consent: consented ? 'yes' : 'no'
    };
  }

  function saveAttributes(attrs) {
    if (!attrs) return;
    clearTimeout(saveTimer);
    saveTimer = setTimeout(function () {
      fetch('/cart.js')
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var merged = Object.assign({}, cart.attributes || {}, attrs);
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: merged })
          });
        })
        .catch(function () {});
    }, 350);
  }

  function handleRoot(root) {
    var attrs = updateView(root);
    saveAttributes(attrs);
  }

  function applyConsent(form) {
    if (!form) return false;
    var consent = form.querySelector('[data-ship-consent]');
    var consented = !!(consent && consent.checked);
    form.querySelectorAll('.ajax-cart__button-submit').forEach(function (btn) {
      if (consented) {
        btn.removeAttribute('disabled');
        btn.classList.remove('kr-ship-disabled');
      } else {
        btn.setAttribute('disabled', 'disabled');
        btn.classList.add('kr-ship-disabled');
      }
    });
    return consented;
  }

  function onChange(event) {
    var form = event.target.closest('form');
    var root = event.target.closest('[data-shipping-calc]');
    if (!root && form) root = form.querySelector('[data-shipping-calc]');
    if (root) {
      handleRoot(root);
      return;
    }
    if (form && event.target.closest('[data-ship-consent]')) {
      saveAttributes({ delivery_consent: applyConsent(form) ? 'yes' : 'no' });
    }
  }

  function setTabOpen(tab, open) {
    var btn = tab.querySelector('.kr-ship-tab__btn');
    var content = tab.nextElementSibling;
    if (!btn || !content || !content.classList.contains('kr-ship-tab__content')) return;
    if (open) {
      content.classList.remove('closed');
      content.style.display = 'block';
      btn.classList.remove('closed');
      tab.classList.remove('closed');
      btn.setAttribute('aria-expanded', 'true');
    } else {
      content.classList.add('closed');
      content.style.display = 'none';
      btn.classList.add('closed');
      tab.classList.add('closed');
      btn.setAttribute('aria-expanded', 'false');
    }
  }

  function openCalc(form) {
    if (!form) return;
    var tab = form.querySelector('.kr-ship-tab');
    if (!tab) return;
    setTabOpen(tab, true);
    tab.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function bindTab(tab) {
    if (!tab || tab.getAttribute('data-ship-tab-ready') === '1') return;
    var btn = tab.querySelector('.kr-ship-tab__btn');
    var content = tab.nextElementSibling;
    if (!btn || !content || !content.classList.contains('kr-ship-tab__content')) return;
    tab.setAttribute('data-ship-tab-ready', '1');
    btn.addEventListener('click', function (event) {
      event.preventDefault();
      setTabOpen(tab, content.classList.contains('closed'));
    });
  }

  function boot(root) {
    if (!root || root.getAttribute('data-ship-ready') === '1') return;
    root.setAttribute('data-ship-ready', '1');
    updateView(root);
  }

  function scan() {
    document.querySelectorAll('[data-shipping-calc]').forEach(boot);
    document.querySelectorAll('.kr-ship-tab').forEach(bindTab);
    document.querySelectorAll('form').forEach(function (form) {
      if (form.querySelector('[data-ship-consent]') && !form.querySelector('[data-shipping-calc]')) {
        applyConsent(form);
      }
    });
  }

  document.addEventListener('change', onChange);
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-ship-open-calc]');
    if (!link) return;
    event.preventDefault();
    event.stopPropagation();
    openCalc(link.closest('form'));
  });
  document.addEventListener('DOMContentLoaded', scan);

  var observer = new MutationObserver(function () {
    scan();
  });

  function observe() {
    document.querySelectorAll('.js-ajax-cart-content').forEach(function (node) {
      observer.observe(node, { childList: true, subtree: true });
    });
    scan();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }
})();
